module.exports = __webpack_public_path__ + "static/tomas-91df0cb6976c3abba8dd4590d99d66df.png";